module.exports = __webpack_public_path__ + "img/green@2x.ca97c79d.png";